var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlanted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 100,
    viewBox: "0 0 295 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295 100L245.287 0H0V100H295Z",
    fill: "#4196F0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlanted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slanted.fe3845a8825ffc821510852b0eecf53c.svg";